import React, { useMemo } from "react";

import { Modal } from "@packages/ds";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { useBannerIsRegistered } from "Reducers/banners";
import { useUrlParamsSubscription } from "Reducers/organization/subscription/hooks";
import { gitProjectSelector } from "Reducers/project/project";

import BannerContainer from "./BannerContainer";
import { SellableProps } from "./types";

const Sellable = (props: SellableProps) => {
  const {
    children,
    sellableName,
    isExist: exist,
    size,
    modal,
    freeOnTrial = true
  } = props;
  const { Comp, onClose: onCloseModal } = modal || {};

  const project = useSelectorWithUrlParams(gitProjectSelector);
  const registered = useBannerIsRegistered(sellableName);
  const subscription = useUrlParamsSubscription() || props.subscription;
  const storageKey = `${subscription?.id}_${sellableName}`;

  const isOpen = useMemo(() => {
    // if exist is undefined, it assumes that the sellable is in subscription
    // so it will look in the root of subscription where most of the sellables
    // are defined using the sellable name as key
    const sellable = exist === undefined ? subscription?.[sellableName] : exist;

    if (!exist && !subscription) return false;

    const isBannerOpen = sessionStorage.getItem(storageKey);

    if (isBannerOpen === "false" || sellable || !sellableName) return false;
    sessionStorage.setItem(storageKey, "true");
    return registered;
    //while visble is not used, it is used to keep the local state with the local storage
    //state in sync
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription, sellableName, registered]);

  const onOpenChange = (isOpen: boolean) =>
    sellableName && sessionStorage.setItem(storageKey, String(isOpen));

  return (
    <>
      <BannerContainer
        onOpenChange={onOpenChange}
        bannerName={sellableName}
        isOpen={isOpen}
        size={size}
        freeOnTrial={freeOnTrial}
      >
        {children}
      </BannerContainer>
      {Comp && isOpen && (
        <Modal handleClose={() => onCloseModal?.(false)} isOpen={!!modal?.open}>
          <Comp
            freeOnTrial={freeOnTrial}
            onClose={onCloseModal}
            subscription={subscription}
            project={project}
            sellableName={sellableName}
          />
        </Modal>
      )}
    </>
  );
};

export default Sellable;
